<template>
  <div>
    <div v-if="packageList.length" class="my-package-list">
      <div
        v-for="item in packageList"
        :key="item.package_id"
        class="my-package-list-item"
        :class="!item.is_valid ? 'opcity' : ''"
      >
        <div class="my-package-list-item-info">
          <img
            :src="item.doctor_avatar"
            alt=""
            class="my-package-list-item-info-avatar"
          />
          <span class="my-package-list-item-info-name">{{
            item.doctor_name
          }}</span>
          <span class="my-package-list-item-info-title">{{ item.title }}</span>
        </div>
        <span class="my-package-list-item-info-sub-title">{{
          item.sub_title
        }}</span>
        <div class="my-package-list-item-time">
          有效期{{ item.start_time }}至{{ item.end_time }}
        </div>
        <div class="my-package-list-item-button" @click="toUse(item)">
          去使用<img
            src="https://resource.chunyu.mobi/@/media/images/2024/04/22/7b27/b87c79ca235c_w15_h24_.png"
            alt=""
            class="my-package-list-item-button-icon"
          />
        </div>
        <img
          v-if="!item.is_valid"
          :src="
            item.sub_title === '已用完'
              ? 'https://resource.chunyu.mobi/@/media/images/2024/04/22/6062/fa18e8568180_w192_h150_.png'
              : 'https://resource.chunyu.mobi/@/media/images/2024/04/22/ec27/1e89dba7fd00_w186_h150_.png'
          "
          alt=""
          class="my-package-list-item-illegal"
        />
      </div>
    </div>
    <div v-else class="my-package-empty">
      <img
        src="https://resource.chunyu.mobi/@/media/images/2024/04/19/fb10/c6454a9f6dfc_w98_h96_.png"
        alt=""
        class="my-package-empty-icon"
      />
      暂无相关内容
    </div>
  </div>
</template>

<script>
import { getMyPackageList } from '@/services/index';
import * as cyDetect from '@cy/detect';
import { doPoint } from '@/utils/index.js';

const wx = require('weixin-js-sdk');

export default {
  data() {
    return {
      packageList: [],
    };
  },
  created() {
    doPoint('PageView', {
      app: cyDetect.isFromWechat() ? 'weixin_mini' : 0,
      page_title: '我的套餐',
    });
    this.getData();
  },
  methods: {
    /**
     * 获取数据
     */
    getData() {
      getMyPackageList().then(res => {
        console.log(res);
        this.packageList = res.package_list;
      });
    },
    /**
     * 去使用
     *
     * @param data
     */
    toUse(data) {
      doPoint('AppClick', {
        app: cyDetect.isFromWechat() ? 'weixin_mini' : 0,
        click_position: '去使用',
        page_title: '我的套餐',
      }).finally(() => {
        if (!data.is_valid) {
          return;
        }
        const payData = {
          type: 'graph',
          info: {
            content_str: '',
            doctor_id: data.doctor_id,
            benefit_package_id: data.package_id,
            type: 2,
            ...(cyDetect.isFromWechat() && {
              partner: 'chunyu_wap_mini',
            }),
          },
        };
        const infoStr = encodeURIComponent(JSON.stringify(payData.info));
        if (cyDetect.isFromWechat()) {
          wx.miniProgram.navigateTo({
            url: `/pages/payment/index?info=${infoStr}&type=graph&mark=benefit_package_use`,
          });
        } else if (cyDetect.isFromCY()) {
          window.location.href = `/weixin/pay/?info=${infoStr}&type=graph&pay_version=2&page_view_type=图文套餐`;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@@/styles/mixin.scss';

.opcity {
  opacity: 0.5;
}
.my-package-list {
  padding: rem(10);
  .my-package-list-item {
    position: relative;
    height: rem(101);
    margin-bottom: rem(10);
    background: url('https://resource.chunyu.mobi/@/media/images/2024/04/15/daa0/cd226307f782_w1065_h303_.png');
    background-size: contain;
    .my-package-list-item-info {
      position: absolute;
      top: rem(42);
      left: rem(15);
      display: flex;
      align-items: center;
      .my-package-list-item-info-avatar {
        width: rem(25);
        height: rem(25);
        border-radius: 50%;
      }
      .my-package-list-item-info-name {
        margin: 0 rem(8);
        color: #323232;
        font-weight: bold;
        font-size: rem(15);
      }
      .my-package-list-item-info-title {
        color: #323232;
        font-weight: bold;
        font-size: rem(15);
      }
    }
    .my-package-list-item-time {
      position: absolute;
      bottom: rem(12);
      left: rem(15);
      color: #666;
      font-size: 13px;
    }
    .my-package-list-item-info-sub-title {
      position: absolute;
      top: rem(12);
      right: rem(15);
      color: #666;
      font-size: rem(13);
    }
    .my-package-list-item-button {
      position: absolute;
      right: rem(15);
      bottom: rem(30);
      width: rem(62);
      height: rem(25);
      color: #fff;
      font-weight: bold;
      font-size: rem(13);
      line-height: rem(25);
      text-align: center;
      background-image: linear-gradient(51deg, #ffdb31 0%, #ff6700 100%);
      border-radius: rem(12.5);
    }
    .my-package-list-item-button-icon {
      width: rem(6);
      height: rem(8);
      margin-left: rem(2);
    }
    .my-package-list-item-illegal {
      position: absolute;
      top: rem(2);
      right: rem(100);
      width: rem(70);
      height: rem(55);
    }
  }
  .my-package-list-alert-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100vw;
    height: 100vh;
    background: rgba($color: #000, $alpha: 0.5);
    .my-package-list-alert {
      position: absolute;
      top: rem(200);
      left: 50%;
      z-index: 10;
      width: rem(300);
      padding: rem(15) rem(20);
      text-align: center;
      background: #fff;
      border-radius: rem(8);
      transform: translateX(-50%);
      .my-package-list-alert-title {
        margin-bottom: rem(15);
        color: #1a1a1a;
        font-size: 18px;
      }
      .my-package-list-alert-content {
        color: #666;
        font-size: 15px;
        line-height: rem(22);
      }
      .my-package-list-alert-contact {
        height: rem(30);
        color: #666;
        font-size: 13px;
        line-height: rem(30);
      }
      .my-package-list-alert-close {
        position: absolute;
        top: rem(15);
        right: rem(20);
        color: #666;
        font-size: rem(18);
      }
    }
  }
}
.my-package-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 80vh;
  color: #666;
  font-size: 15px;
  .my-package-empty-icon {
    width: rem(50);
    height: rem(50);
    margin-bottom: rem(20);
  }
}
</style>
